export const SEPARATE_ORDER = 'SEPARATE_ORDER';
export const ADDED_TO_NEXT_ORDER = 'ADDED_TO_NEXT_ORDER';
